import { Injectable } from '@angular/core';
import { Observable, Subject, Observer } from 'rxjs';
import { BreadDik, CustomgridObservableParam, CustomgridSortAndFilter } from '../models';
import { BreadcrumbService } from '../services';


@Injectable({
  providedIn: 'root'
})

export class CustomGridService {

  public paramList: Array<CustomgridObservableParam> = [];



  public param: Subject<any> = new Subject<any>();

  constructor(private breadcrumbService: BreadcrumbService) { }

  // load element
  sendItem(key: string, param: any): void {
    if (key !== '') {
      const result: Array<CustomgridObservableParam> = this.paramList.filter(e => e.key === key)
      if (result.length !== 0) {
        result[0].param.next(param);
      }
      else {
        this.param.next(param);
      }
    }
    else {
      this.param.next(param);
    }
  }

  // return element
  getItem(key: string = ''): Observable<any> {

    if (key !== '') {
      const result: Array<CustomgridObservableParam> = this.paramList.filter(e => e.key === key)
      if (result.length === 0) {
        let item: CustomgridObservableParam = new CustomgridObservableParam(key);
        item.param.observers = new Array<Observer<any>>();
        this.paramList.push(item);
        return item.param.asObservable();
      }
      else {
        return result[0].param.asObservable();
      }
    }
    else {
      this.param.observers = new Array<Observer<any>>();
      return this.param.asObservable();
    }
  }

  dropItem(key: string): void {
    const result: Array<CustomgridObservableParam> = this.paramList.filter(e => e.key === key)
    if (result.length !== 0) {
      let itemToDelete: Array<CustomgridObservableParam> = this.paramList.splice(this.paramList.indexOf(result[0]), 1);
      if (itemToDelete.length > 0) {
        itemToDelete[0].key = '';
        if (itemToDelete[0].param)
          itemToDelete[0].param.unsubscribe();
      }
    }
  }

  // Sauvegarde des filtres et des tris
  public filtersortList: Array<CustomgridSortAndFilter> = [];
  public addFilter(key: string, filters: { [key: string]: any })
  {
    const result: Array<CustomgridSortAndFilter> = this.filtersortList.filter(e => e.key === key)
    if (result.length === 0) {
      let item: CustomgridSortAndFilter = new CustomgridSortAndFilter(key);
      item.filters = filters;
      this.filtersortList.push(item);
    }
    else {
      result[0].filters = filters;
    }
  }
  public addSort(key: string, sorts: { [key: string]: any }) {
    const result: Array<CustomgridSortAndFilter> = this.filtersortList.filter(e => e.key === key)
    if (result.length === 0) {
      let item: CustomgridSortAndFilter = new CustomgridSortAndFilter(key);
      item.sorts = sorts;
      this.filtersortList.push(item);
    }
    else {
      result[0].sorts = sorts;
    }
  }

  public getSortAndFilter(key: string): CustomgridSortAndFilter | null {
    const result: Array<CustomgridSortAndFilter> = this.filtersortList.filter(e => e.key === key)
    if (result.length === 0)
      return null
    else
      return result[0]
  }


  /** @description check from breadcrumb service if we came from Breadcrumb Back()
 * @return boolean
 */
  public IsComingFromABacktrack(): boolean {
    return this.breadcrumbService.Breadcrumb[this.breadcrumbService.Breadcrumb.length - 1].data.params.filter((el: BreadDik) => el.key === 'childFrom').length > 0;
  }


}

